import { useTranslation } from 'react-i18next'
import { brandInfo } from '@/mocks/site'
import { weddingFaqIds } from '@/mocks/wedding'
import PageSeo from '@/components/feature/PageSeo'
import { SITE_URL, businessAddress, businessAreaServed } from '@/utils/schema'

export default function WeddingSeo() {
  const { t } = useTranslation()

  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Wedding Photography',
    name: t('pages.wedding.title'),
    description: t('pages.wedding.description', { phone: brandInfo.phone }),
    areaServed: businessAreaServed,
    provider: {
      '@type': 'PhotographyBusiness',
      name: brandInfo.name,
      image: brandInfo.logoImage,
      telephone: brandInfo.phone,
      email: brandInfo.email,
      url: SITE_URL,
      foundingDate: brandInfo.since,
      priceRange: '₹₹',
      address: businessAddress,
      areaServed: businessAreaServed,
    },
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      areaServed: { '@type': 'City', name: 'Madurai' },
    },
  }

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: weddingFaqIds.map((id) => ({
      '@type': 'Question',
      name: t(`wedding.faq.items.${id}.q`),
      acceptedAnswer: {
        '@type': 'Answer',
        text: t(`wedding.faq.items.${id}.a`),
      },
    })),
  }

  return (
    <PageSeo
      title={t('seo.wedding.title')}
      description={t('seo.wedding.description')}
      path="/wedding"
      schemas={[serviceSchema, faqSchema]}
    />
  )
}